import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DeletePlaylistModalComponent } from '@app/library/components/modals/delete-playlist-modal/delete-playlist-modal.component';
import { MobCreatePlaylistComponent } from '@app/library/components/sides/mob-create-playlist/mob-create-playlist.component';
import { Playlist } from '@app/library/models/playlist.model';
import { EndEditPlaylist } from '@app/library/states/playlists.actions';
import { PlaylistsState } from '@app/library/states/playlists.state';
import { MOBILE_DIALOG_CONFIG } from '@app/shared/constants';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-playlist-context-menu',
  templateUrl: './playlist-context-menu.component.html',
  styleUrls: ['./playlist-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaylistContextMenuComponent {
  @Select(PlaylistsState.editingPlaylist)
  playlist$: Observable<Playlist>;

  constructor(
    private readonly dialogRef: MatDialogRef<PlaylistContextMenuComponent>,
    private readonly dialog: MatDialog,
    private readonly elRef: ElementRef,
  ) {}

  editPlaylist(playlist: Playlist) {
    this.exitPanel();
    const dialogRef = this.dialog.open(MobCreatePlaylistComponent, {
      ...MOBILE_DIALOG_CONFIG,
      data: {
        playlist,
      },
    });
    dialogRef.afterClosed().subscribe(() => new EndEditPlaylist());
  }

  deletePlaylist(playlist: Playlist) {
    this.elRef.nativeElement.closest('.mobile-dialog').classList.add('behind-modal');
    const deleteRef = this.dialog.open(DeletePlaylistModalComponent, {
      ...MOBILE_DIALOG_CONFIG,
      data: {
        playlist,
        mobile: true,
      },
    });
    deleteRef.afterClosed().subscribe(() => {
      this.elRef.nativeElement.closest('.mobile-dialog').classList.remove('behind-modal');
    });
  }

  exitPanel() {
    this.dialogRef.close();
  }
}
